export default __webpack_public_path__ + "static/media/edit.d52754d9.jpg";